// 試合（duel_games.status）の手で付ける目印: 使う（active）か使わない（disabled）か（Issue #988）。
// サーバーの `synchro_server/constants.py::DUEL_STATUSES` と 1 対 1（ずれたらサーバーが正）。
// 進み具合は目印ではなく、本番が数える試合のチェックリスト（GetDuelListProject の games[].checks。`GAME_CHECKS`）。
// 以前は 10 個 → 4 個（Issue #469）→ 2 個。
export const DUEL_STATUSES = ['active', 'disabled'];

export const STATUS_LABEL = {
  active:   '使う',
  disabled: '使わない',
};

export const STATUS_BADGE = {
  active:   'badge-active',
  disabled: '',
};

// 試合のチェックリスト（左から順に入っていく。本番が数える）
export const GAME_CHECKS = [
  ['decided', '決着'],
  ['timing', '位置合わせ'],
  ['export', '書き出し'],
];

// デュエル（duels.stage）の段。サーバーの `DUEL_STAGES` と 1 対 1。人が付ける（試合のチェックリストとは連動しない）。archived だけはアーカイブのジョブが付ける
export const DUEL_STAGES = ['open', 'filmed', 'exported', 'archived', 'on_hold'];

export const STAGE_LABEL = {
  open:     '準備中',
  filmed:   '撮影済み',
  exported: '書き出し済み',
  archived: 'アーカイブ済み',
  on_hold:  '保留中',
};

export const STAGE_BADGE = {
  open:     'badge-pending',
  filmed:   'badge-active',
  exported: 'badge-finished',
  archived: '',
  on_hold:  '',
};

// 人が選べる段（archived はアーカイブのジョブだけが付ける）
export const SETTABLE_STAGES = ['open', 'filmed', 'exported', 'on_hold'];

// 一覧の既定（「進行中」）で隠す段
export const HIDDEN_STAGES = ['exported', 'archived', 'on_hold'];

/** 使わない試合か。 */
export const isClosedStatus = status => status === 'disabled';

/** 試合のチェックが全部入っているか。 */
export const isComplete = checks => GAME_CHECKS.every(([k]) => checks?.[k]);
